<template>
	<div v-if="reviewsStore.reviews.total" class="IW is-inline-block">

		<div v-if="design === 1" class="rating_box_1">
			<div>
				<rate-component :value="reviewsStore.averageRating" disabled></rate-component>
			</div>
			<div class="text">
				{{ reviewsStore.averageRating.toFixed(2).replace(".", ",") }} / 5 Sterne bei {{ reviewsStore.reviews.total }} Bewertungen
			</div>
		</div>

		<div v-if="design === 2" class="rating_box_2">
			<div class="has-text-weight-bold">
				Immobilienwerker
			</div>
			<div class="reviewScore">
				{{ reviewsStore.averageRating.toFixed(2).replace(".", ",") }} / 5
			</div>
			<div class="ratingText">
				{{ reviewsStore.ratingText }}
			</div>
			<div>
				<rate-component :value="reviewsStore.averageRating" disabled></rate-component>
			</div>
			<div>
				{{ reviewsStore.reviews.total }} Bewertungen
			</div>
		</div>

		<div v-if="design === 3" class="rating_box_3">
			<div>
				<div class="platform">
					<img alt="Trustpilot" class="image" src="@/assets/reviews/trustpilot.png">
					<div class="text">Trustedshops Bewertungen</div>
				</div>
				<div class="stars">
					<rate-component :value="reviewsStore.averageRating" disabled></rate-component>
					<div class="platform-text">{{ reviewsStore.averageRating.toFixed(2).replace(".", ",") }} Sterne</div>
				</div>
			</div>
		</div>

		<div v-if="design === 4" class="rating_box_4">
			<div>
				<div class="stars">
					<rate-component :value="reviewsStore.averageRating" disabled></rate-component>
					<div class="platform-text">
						<b>{{ reviewsStore.averageRating.toFixed(2).replace(".", ",") }} Sterne</b>
						<span class="ml-1 ">({{ reviewsStore.reviews.total }} Bewertungen)</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import {useReviewsStore} from "@/store/reviews";

const reviewsStore = useReviewsStore()
// eslint-disable-next-line no-undef
defineExpose({reviewsStore})

</script>
<script>

export default {
	name: 'ReviewsPartial',
	components: {},
	data() {
		return {
			page: 1,
			perPage: 10,
			isLoadingMore: false,
		}
	},
	props: {
		design: {
			type: Number,
			required: false,
			default: 1,
		},
	},
	mounted() {
		this.initReviews();
	},
	computed: {},
	methods: {

		async initReviews() {
			if (this.reviewsStore.shouldFetchReviews) {
				await this.reviewsStore.fetchReviews();
			}
		},
	},

	beforeMount() {
	},
}
</script>

<style scoped>
.rating_box_1 {
	display: flex;
	font-size: 18px;
	gap: 5px;
	background: white;
	border-radius: 6px;
	box-shadow: 0 .5em 1em -.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
	color: #494949;
	padding: .75rem;
}

.rating_box_1 .text {
	display: flex;
	align-items: center;
}

.rating_box_2 {
	text-align: center;
	display: flex;
	flex-direction: column;
	font-size: 18px;
	gap: 10px;
	background: white;
	border-radius: 6px;
	box-shadow: 0 .5em 1em -.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
	color: #494949;
	padding: .75rem;

}

.rating_box_2 .reviewScore {
	font-size: 24px;
	font-weight: 700;
}

.rating_box_2 .ratingText {
	font-weight: 700;
	font-size: 14px;
}

.rating_box_3 {
	text-align: left;
	width: 100%;
	display: flex;
	padding: .5rem;
	flex-direction: row;
	align-items: center; /* Vertikale Zentrierung */
	font-size: 18px;
	gap: 0;
	background: #f9f9f9;
	border: 1px solid lightgray;
	border-radius: 6px;
	min-height: 60px; /* Ensure minimum height for vertical centering */
}

.rating_box_3 .platform {
	align-items: center;
	display: flex;
	column-gap: .5rem;
}

.rating_box_3 .platform .image {
	max-width: 100px;
	width: 25px
}

.rating_box_3 .platform .text {
	font-size: 18px;
	font-weight: 600;
	display: flex;
	align-items: center;
}

.rating_box_3 .stars {
	display: flex;
	flex-direction: row;
	align-items: baseline;
	gap: .5rem;
}

.rating_box_3 .stars .platform-text {
	font-size: 1rem;
	display: flex;
	align-items: center;

}

.rating_box_4 {
	text-align: left;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center; /* Vertikale Zentrierung */
	font-size: 18px;
	gap: 0;
	border-radius: 6px;
	flex-wrap: wrap;
	justify-content: flex-end;
}

.rating_box_4 .platform .text {
	font-size: 18px;
	font-weight: 600;
	display: flex;
	align-items: center;
}

.rating_box_4 .stars {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: .5rem;
}

.rating_box_4 .stars .platform-text {
	font-size: 18px;
	display: flex;
	align-items: center;
}
</style>
